import React from "react";
import Navbar from "../../partials/Navber";
import Footer from "../../partials/Footer";
import CartModal from "../../partials/CartModal";

const sections = [
  {
    title: "1. Direito de Arrependimento",
    content: `De acordo com o Código de Defesa do Consumidor (Lei nº 8.078/1990), você pode desistir da compra realizada na loja online da Flitz em até 7 (sete) dias corridos a partir do recebimento do produto. Para isso, o item deve estar sem uso, com embalagem original, nota fiscal e todos os acessórios.

**Para solicitar a devolução:**
1. Envie um e-mail para contato@flitzbr.com.br dentro do prazo legal.
2. Informe o número do pedido, motivo da devolução e escolha entre troca ou reembolso.
3. Nossa equipe orientará o processo de envio do produto.

**Reembolso:**
- Realizado pelo mesmo meio de pagamento da compra.
- Em cartão de crédito, pode levar até duas faturas para aparecer.
- No caso de boleto, o valor será depositado na conta indicada pelo cliente em até 10 dias úteis após a análise do produto.`,
  },
  {
    title: "2. Produtos com Defeito",
    content: `Caso seu produto apresente defeito de fabricação dentro do prazo legal de 90 dias, conforme o artigo 26 do CDC, você poderá solicitar troca ou reparo.

**Para solicitar troca por defeito:**
1. Envie um e-mail para contato@flitzbr.com.br com número do pedido, descrição do defeito e fotos do produto.
2. Forneceremos as instruções para envio do item para análise.

**Análise técnica:**
- O produto será avaliado em até 30 dias corridos após o recebimento.
- Se confirmado o defeito, você poderá optar por:
  • Um novo produto sem custo adicional;
  • Um vale-compra no mesmo valor;
  • Reembolso integral.
- Caso não seja constatado defeito, o produto será devolvido ao cliente.`,
  },
  {
    title: "3. Condições Gerais",
    content: `Não aceitamos devoluções de produtos com:
- Sinais de uso ou mau uso;
- Danos causados por quedas, impacto ou desgaste natural;
- Falta de nota fiscal ou acessórios.

A Flitz se reserva o direito de recusar devoluções que não atendam aos critérios e reenviar o produto sem aviso prévio.`,
  },
  {
    title: "4. Contato",
    content: `Em caso de dúvidas ou solicitações, fale com a nossa equipe:
E-mail: contato@flitzbr.com.br`,
  },
];

const Devolu = () => {
  return (
    <>
      <Navbar />
      <main className="bg-white text-gray-800 min-h-screen mt-24 px-6 md:px-20 lg:px-40 py-12">
        <h1 className="text-4xl font-semibold mb-12 text-gray-900 text-center">
          Política de Troca e Devolução - Flitz
        </h1>
        <div className="space-y-16">
          {sections.map((section, index) => (
            <section key={index} className="scroll-mt-24 border-b border-gray-200 pb-10">
              <h2 className="text-2xl font-medium text-gray-900 mb-4">{section.title}</h2>
              <p className="text-base leading-relaxed whitespace-pre-line text-gray-700">
                {section.content}
              </p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
      <CartModal />
    </>
  );
};

export default Devolu;